import { render, staticRenderFns } from "./UpperMatch.vue?vue&type=template&id=f859ecea&scoped=true"
import script from "./UpperMatch.vue?vue&type=script&lang=js"
export * from "./UpperMatch.vue?vue&type=script&lang=js"
import style0 from "./UpperMatch.vue?vue&type=style&index=0&id=f859ecea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f859ecea",
  null
  
)

export default component.exports